export const RegionFilterOptions = () => {
  return [
    { label: "Sua cidade", value: "CITY" },
    { label: "Seu estado", value: "UF" },
    { label: "Sua região", value: "REGION" },
    { label: "Brasil", value: "COUNTRY" },
  ];
};
export const VersionFilterOptions = () => {
  return [
    { label: "Versão e ano", value: "TRIM_YEAR" },
    { label: "Versão e anos similares", value: "TRIM_SIMILAR" },
    { label: "Modelo e ano", value: "MODEL_YEAR" },
    { label: "Modelo e anos similares", value: "MODEL_SIMILAR" },
  ];
};

const dateFunction = (months: number) => {
  let a = new Date();
  a.setMonth(a.getMonth() - months);
  return a;
};

export const DateFilterOptions = () => {
  return [
    { label: "Últimos 30 dias", value: dateFunction(1) },
    { label: "Últimos 3 meses", value: dateFunction(3) },
    { label: "Últimos 6 meses", value: dateFunction(6) },
    { label: "Últimos 12 meses", value: dateFunction(12) },
  ];
};
export const GroupFilterOptions = () => {
  return [
    { label: "Loja", value: "EVAL_DEALER" },
    { label: "Todos do seu grupo", value: "OEM_DEALER" },
    { label: "Todos", value: "ALL" },
  ];
};
